const Drawer = {
  parts: [
    'dialog',
    'dialogContainer',
    'overlay',
    'closeButton',
    'header',
    'body',
    'footer',
  ],
  baseStyle: {
    dialog: {
      zIndex: 12500,
      maxWidth: {
        base: '100%',
        md: '336px',
      },
    },
    dialogContainer: {
      zIndex: 12500,
    },
    overlay: {
      zIndex: 12000,
    },
    closeButton: {
      right: 6,
      top: 5,
    },
    header: {
      color: 'gray.900',
      fontSize: 'md',
      fontWeight: 'normal',
      textAlign: 'center',
      px: 6,
      py: 6,
    },
    body: {
      px: 6,
      py: 6,
    },
    footer: {
      borderTop: '1px solid',
      borderTopColor: 'gray.100',
      px: 6,
      py: 6,
    },
  },
};

export default Drawer;
